var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#E0AF04"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3197 18.7264L19.0723 24.9738C18.612 25.4342 17.8637 25.4342 17.4033 24.9738C16.943 24.5135 16.943 23.7652 17.4033 23.3049L25.6656 15.0427C26.1259 14.5812 26.8742 14.5812 27.3345 15.0427L35.5967 23.3049C36.0571 23.7652 36.0571 24.5135 35.5967 24.9738C35.1364 25.4342 34.3881 25.4342 33.9278 24.9738L27.6804 18.7264V37.1228C27.6804 37.7744 27.1516 38.3031 26.5 38.3031C25.8485 38.3031 25.3197 37.7744 25.3197 37.1228V18.7264Z",
    fill: "#844C0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.3276,
    height: 28.3276,
    fill: "white",
    transform: "translate(12.3362 12.3362)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.7c88a9bb9e9c1e6032d077f723dd5397.svg";
export { ForwardRef as ReactComponent };